import {
  // getCarModelOeCodes,
  prebuy,
  saveOrUpdate,
  // getDataList,
  // getListAddress,
  getattention
} from '@/api/goodsList.js'
import { getbuygoods } from '@/api/Partsdetails'
export const JPremit = {
  data() {
    return {
      cityList: [],
      isCity: '',
      spinShow: false,
      show: false,
      pager: {
        current: 1,
        total: 0,
        size: 10
      },
      dataList: [],
      tenantId: JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
        .tenantId
    }
  },
  methods: {
    //  *********** 动画样式 *********
    beforeEnter(el) {
      el.style.opacity = 0
    },
    enter(el, done) {
      // console.log(el.dataset.index)
      let delay = el.dataset.index * 100
      setTimeout(() => {
        el.style.transition = 'opacity 0.4s '
        el.style.opacity = 1
        el.style.animation = 'one-in 0.4s infinite'
        el.style['animation-iteration-count'] = 1
        done()
      }, delay)
    },
    // *********** 样式结束 *********
    // 赋值起订量给maxNum
    getMaxNum() {
      this.dataList.forEach(item => {
        item.maxNum = item.orderQuantity ? item.orderQuantity : 1
      })
      // console.log(this.dataList)
    },
    // 配件类型
    partCheckd(val) {
      console.log(val)
      this.partCheck = val.id
      this.searchData.partType = val.id
      this.searchData.brandId = ''
      this.getDataList()
      this.brandCheck = '-1'
    },
    // 配件品牌
    brandCheckd(val) {
      console.log(val)
      this.brandCheck = val
      this.searchData.carBrandName = val === '不限' ? '' : val
      this.getDataList()
    },
    // 分页
    changeCurrent(current) {
      console.log(current)
      this.pager.current = current
      this.searchData.current = current
      console.log(this.searchData)
      console.log(this.pager)
      // this.searchData.size = 1
      // this.pager.size = 1
      this.getDataList()
    },
    changeSize(size) {
      // debugger
      console.log(size)
      this.searchData.size = size
      this.pager.size = size
      this.pager.current = 1
      this.searchData.current = 1
      this.getDataList()
    },
    // 有货
    hasGoodsChange(status) {
      this.searchData.inStock = status ? 1 : ''
      this.changeListsBtn()
    },
    //只显示活动(这期暂未做)
    // isActiveChange(status) {
    //   this.searchData.isActivity = status ? 1 : ''
    //   this.changeListsBtn()
    // },
    // 改变按钮（清空搜索条件前的分页条件）
    changeListsBtn() {
      this.pager = {
        current: 1,
        size: 10,
        total: 0
      }
      this.searchData.size = 10
      this.searchData.current = 1

      this.getDataList()
    },
    // 筛选发货地（市区）
    chioce(item) {
      // console.log(item)
      this.searchData.shipCityId = item.id
      this.getDataList()
    },
    // 跳转配件商品详情
    goDetails(item) {
      // console.log(item)
      this.$router.push({
        path: '/Partsdetails',
        query: {
          partId: item.partId
        }
      })
    },
    // 跳转店铺
    goShop(item) {
      // console.log(item)
      this.$router.push({
        path: '/homePage',
        query: {
          tenantId: item.tenantId,
          shopId: item.shopId,
          shopName: item.shopName
        }
      })
    },
    // 鼠标经过(展开oe码)
    async getRelevance(partId, index, item) {
      // console.log(partId)
      // console.log(item)
      this.$set(this.dataList[index], 'isShow', true)
      // var arr = item.slice(1)
      // this.$set(this.dataList[index], 'oemCodes', arr)
      // this.dataList[index].slice(1)
      // let res = await getCarModelOeCodes({ partId })
      // console.log(res)
      // if (res.status == true) {
      //   if(res.data.oeCodes == null){
      //     res.data.oeCodes =[]
      //   }else{
      //     this.$set(this.dataList[index], 'oeCodes', res.data.oeCodes)
      //   }

      // this.$set(this.dataList[index], 'carModel', res.data.carModel)
      // }
    },
    // 鼠标移开(关闭oe)
    closeRelevance(index) {
      // console.log(index)
      this.$set(this.dataList[index], 'isShow', false)
    },
    // 鼠标移开(关闭发货地)
    closeCity(index) {
      // console.log(index)
      this.$set(this.dataList[index], 'isShows', false)
    },
    // 发货地选中
    checkCITY(i, item) {
      // console.log(i, item)
      this.isCity = i.name
      item.shipCityStore = i
      item.stock = i.stock
    },
    // 鼠标经过(展开发货地)
    getCity(partId, index, item) {
      // console.log(partId)
      // console.log(item)
      this.isCity = item.shipCityStore.name
      // this.isCity = item.oemCodes[0]
      // console.log(this.isCity)
      this.$set(this.dataList[index], 'isShows', true)
    },
    // 立即询价
    enquiry(item) {
      // console.log(item)
      // this.enquirytk = true
      this.enquirydata = JSON.parse(JSON.stringify(item))
      this.$refs.enquirytkl.enquirytkc()
      // this.enquirydata = item
      console.log(this.enquirydata)
    },
    // 询价刷新
    enquirysx() {
      this.$refs.shopcar.getenquirydata()
    },
    // 立即购买
    async prebuy(item) {
      // console.log(item)
      let reg = /^[1-9]\d*$/
      if (!reg.test(item.maxNum)) {
        this.$Message.error('请输入正确的购买数量！')
        return
      }
      if (item.maxNum > item.stock) {
        this.$Message.destroy()
        this.$Message.error('购买数量不能大于库存!')
        return
      }
      if (item.maxNum < item.orderQuantity) {
        this.$Message.destroy()
        this.$Message.error('购买数量不能小于起订数量!')
        return
      }
      if (item.stock == 0) {
        this.$Message.destroy()
        this.$Message.error('无库存，不可购买')
        return
      }
      let data = ''
      this.$set(item, 'buyLoading', true)
      // if (i) {
      data = {
        partId: item.partId,
        tenantId: item.tenantId,
        partNum: item.maxNum ? item.maxNum : item.orderQuantity,
        shopId: item.shopId,
        storeId: item.shipCityStore.storeId
      }
      // } else {
      //   data = {
      //     partId: item.partId,
      //     tenantId: item.tenantId,
      //     partNum: item.maxNum ? item.maxNum : item.orderQuantity,
      //     shopId: item.shopId
      //   }
      // }

      console.log(1212)
      console.log(item)
      let res = await prebuy(data)
      console.log(res)
      this.$set(item, 'buyLoading', false)
      if (res.status == true) {
        if (res.data.previewOrderId) {
          this.$router.push({
            path: '/orderInformation',
            query: {
              pid: res.data.previewOrderId
            }
          })
        }
      }
    },
    // 加入购物车
    async setShopCat(item, index) {
      console.log('加购 ')
      console.log(item)
      let reg = /^[1-9]\d*$/
      if (!reg.test(item.maxNum)) {
        this.$Message.error('请输入正确的购买数量！')
        return
      } else {
        this.spinShow = true
      }
      item.maxNum = item.maxNum ? item.maxNum : item.orderQuantity
      if (item.maxNum > item.stock) {
        this.$Message.error('购买数量不能大于库存!')
        this.$nextTick(() => {
          // this.dataList[index].maxNum = this.dataList[index].stock
        })
        setTimeout(() => {
          this.spinShow = false
        }, 500)
        return
      }
      if (item.stock == 0) {
        this.$Message.error('无库存，不可加购')
        setTimeout(() => {
          this.spinShow = false
        }, 500)
        return
      }
      let userData = JSON.parse(sessionStorage.getItem('userData'))
      console.log(userData)
      let data = ''
      // if (cehcekWare) {
      data = {
        tenantId: item.tenantId,
        shopId: item.shopId,
        shopName: item.shopName,
        partId: item.partId,
        partCode: item.oeCode,
        partNum: item.maxNum,
        partQualityType: item.qualityTypeId,
        carBrandName: item.carBrandName,
        partInnerId: item.partInnerId,
        price: item.price,
        direction: item.direction,
        stdNameJp: item.stdNameJp ? item.stdNameJp : '',
        storeId: item.shipCityStore.storeId
      }
      // } else {
      //   data = {
      //     tenantId: item.tenantId,
      //     shopId: item.shopId,
      //     shopName: item.shopName,
      //     partId: item.partId,
      //     partCode: item.oeCode,
      //     partNum: item.maxNum,
      //     partQualityType: item.qualityTypeId,
      //     carBrandName: item.carBrandName,
      //     partInnerId: item.partInnerId,
      //     price: item.price,
      //     direction: item.direction,
      //     stdNameJp: item.stdNameJp ? item.stdNameJp : ''
      //   }
      // }
      console.log(data)
      let res = await saveOrUpdate(data)
      this.$refs.shopcar.getCount()
      setTimeout(() => {
        this.spinShow = false
      }, 500)
      console.log(res)
      if (res.code == 200) {
        this.$Message.success('加购成功！')
        this.getDataList()
        this.$nextTick(() => {
          this.dataList[index].maxNum = this.dataList[index].orderQuantity
        })
      }
    },
    // 修改商品数量的最大值调整
    async changeNum(item, index) {
      console.log(this.tenantId, item.tenantId)
      console.log(item, index)
      let reg = /^[1-9]\d*$/
      if (!reg.test(item.maxNum)) {
        this.$Message.error('请输入正确的购买数量！')
        // this.dataList[index].maxNum = item.orderQuantity
      }
      if (item.inquiry == 1) {
      } else {
        const res = await getbuygoods({
          tenantId: item.tenantId,
          shopId: item.shopId,
          partId: item.partId,
          partNum: item.maxNum,
          storeId: item.shipCityStore.storeId
        })
        if (res.status) {
          item.price = res.data.price
        }
      }

      this.$nextTick(() => {
        if (item.maxNum > item.stock) {
          this.$Message.error('购买数量超过库存数量!')
          this.dataList[index].maxNum = item.stock
        }
        if (item.maxNum <= item.orderQuantity) {
          this.dataList[index].maxNum = item.orderQuantity
        }
      })
      console.log(this.dataList[index].maxNum)
    },
    async BlurNumber(item, index) {
      console.log(item, index)
      let reg = /^[1-9]\d*$/
      if (!reg.test(item.maxNum)) {
        this.$Message.error('请输入正确的购买数量！')
      } else {
        if (item.inquiry == 1) {
        } else {
          // if (item.maxNum > item.stock || item.maxNum == item.stock) {
          // this.$set(this.dataList[index], 'Add', true)
          console.log('333333')
          if (item.maxNum > item.stock) {
            this.$set(this.dataList[index], 'isNumber', true)
            this.$set(this.dataList[index], 'Add', true)
            this.$set(this.dataList[index], 'Sub', false)
          } else if (item.maxNum == item.stock) {
            this.$set(this.dataList[index], 'isNumber', false)
          }
          // }
          else {
            this.$set(this.dataList[index], 'Add', false)
            this.$set(this.dataList[index], 'isNumber', false)
            this.$set(this.dataList[index], 'Sub', false)
            if (item.maxNum == 1) {
              this.$set(this.dataList[index], 'Sub', true)
            }
          }
          const res = await getbuygoods({
            tenantId: item.tenantId,
            shopId: item.shopId,
            partId: item.partId,
            partNum: item.maxNum,
            storeId: item.shipCityStore.storeId
          })
          if (res.status) {
            item.price = res.data.price
            // this.$set(this.dataList[index], 'isNumber', false)
          }
        }
        // }
      }
    },
    // 减法
    cliSub(item, index) {
      if (item.maxNum == 1) {
        // this.$set(this.dataList[index], 'Sub', true)
      } else {
        let oipt = document.getElementById(index)
        this.$delete(this.dataList[index], 'maxNum')
        this.$set(this.dataList[index], 'maxNum', oipt.value * 1 - 1)
        this.BlurNumber(item, index)
        // this.$set(this.dataList[index], 'Sub', false)
      }
    },
    // 加法
    cliAdd(item, index) {
      if (item.maxNum == item.stock) {
        this.$set(this.dataList[index], 'Add', true)
      } else {
        let oipt = document.getElementById(index)
        this.$delete(this.dataList[index], 'maxNum')
        this.$set(this.dataList[index], 'maxNum', oipt.value * 1 + 1)
        this.BlurNumber(item, index)
      }
    },
    // 点击综合
    synthesisChecked() {
      this.checkNum = 0
      this.inventoryNum = 0
      this.searchData.stockSort = ''
      this.priceNum = 0
      this.searchData.priceSort = ''
      this.changeListsBtn()
    },
    // 点击库存
    inventoryChecked() {
      this.checkNum = 1
      this.priceNum = 0
      this.searchData.priceSort = ''
      this.inventoryNum += 1
      console.log(this.inventoryNum)
      if (this.inventoryNum % 2 == 0) {
        this.searchData.stockSort = 1
      } else {
        this.searchData.stockSort = 2
      }
      console.log(this.searchData.stockSort)
      this.changeListsBtn()
    },
    // 点击价格
    priceChecked() {
      this.checkNum = 2
      this.inventoryNum = 0
      this.searchData.stockSort = ''
      this.priceNum += 1
      if (this.priceNum % 2 == 0) {
        this.searchData.priceSort = 1
      } else {
        this.searchData.priceSort = 2
      }
      console.log(this.searchData.priceSort)
      this.changeListsBtn()
    },
    // 关注
    async collect(item) {
      item.attention = !item.attention
      //console.log('收藏')
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      const res = await getattention({
        partId: item.id,
        attention: item.attention
      })
      //console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
    }
  }
}
